import type { ReactNode } from "react";
import { X } from "lucide-react";

/** What can be done with the rows ticked in a list. It floats at the foot of the page. */
export function SelectionBar({ count, children, onClear }: { count: number; children: ReactNode; onClear: () => void }) {
  return <div className="bw-area-selection" role="toolbar" aria-label="Selected items">
    <strong>{count} selected</strong>
    {children}
    <button type="button" className="bw-btn bw-btn--icon" aria-label="Clear selection" onClick={onClear}><X size={16} aria-hidden="true" /></button>
  </div>;
}
